if (!customElements.get('mega-menu')) {
  class MegaMenu extends HTMLElement {
    constructor() {
      super();

      this.details = this.closest('details');
      this.initTabs();
      this.initScroll();
      
      // Bind methods
      this.calculateMaxHeight = this.calculateMaxHeight.bind(this);
      

      // Initialize height calculation after DOM is fully loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(this.calculateMaxHeight, 250);
        });
      } else {
        setTimeout(this.calculateMaxHeight, 250);
      }
      
      // Add resize listener with debounce
      window.addEventListener('resize', this.debounce(this.calculateMaxHeight, 250));
    }

    calculateMaxHeight() {
      const tabTargets = this.querySelectorAll('.mega-menu__subnav ul[data-target]');
      if (!tabTargets.length) return;

      let maxHeight = 0;
      
      // First, find the active element and get its width
      const activeElement = this.querySelector('.mega-menu__subnav ul[data-target].active');
      if (!activeElement) return;
      
      const activeWidth = activeElement.offsetWidth;

      // Reset heights and visibility temporarily
      tabTargets.forEach(target => {
        // Store original states
        const originalVisibility = target.style.visibility;
        const originalDisplay = target.style.display;
        const originalPosition = target.style.position;
        const originalMaxWidth = target.style.maxWidth;
        
        // Make element visible but hidden
        target.style.visibility = 'hidden';
        target.style.display = 'block';
        target.style.position = 'static'; // Temporarily remove absolute positioning
        target.style.maxWidth = `${activeWidth}px`; // Set width to match active element
        target.style.height = 'auto';
        
        // Get the height
        const height = target.offsetHeight;
        maxHeight = Math.max(maxHeight, height);
        
        // Restore original states
        target.style.visibility = originalVisibility;
        target.style.display = originalDisplay;
        target.style.position = originalPosition;
        target.style.maxWidth = originalMaxWidth;
      });

      if (maxHeight > 0) {
        // Add additional height based on viewport width
        let additionalHeight = 40; // default additional height
        if (window.innerWidth >= 1440) {
          additionalHeight = 80;
        }

        // Set the CSS variable with the calculated height

        document.documentElement.style.setProperty(
          '--mega-menu-min-height', 
          `${maxHeight + additionalHeight}px`
        );
      }
    }

    debounce(fn, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          fn(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    initTabs() {
      this.addEventListener('click', (event) => {
        const tabNav = event.target.closest('[data-tab]');
        if (!tabNav) return;

        event.preventDefault();
        const tabName = tabNav.dataset.tab;
        this.updateTabs(tabName);
      });
    }

    initScroll() {
      window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        const menuTop = (this.offsetTop + this.offsetHeight) + 100;

        if (currentScrollY > this.lastScrollY && currentScrollY > menuTop) {
          // this.closeDetails();
        }

        this.lastScrollY = currentScrollY;
      });
    }

    updateTabs(tabName) {
      // Get all mega-menu elements
      const allMenus = document.querySelectorAll('mega-menu');

      allMenus.forEach((menu) => {
        // Get all tab navigation elements in the current menu
        const tabNavs = menu.querySelectorAll('[data-tab]');
        const tabTargets = menu.querySelectorAll('[data-target]');

        // Activate the clicked tab and deactivate others
        tabNavs.forEach((nav) => {
          nav.classList.toggle('active', nav.dataset.tab === tabName);
        });

        // Show the matching tab content and hide others
        tabTargets.forEach((target) => {
          target.classList.toggle('active', target.dataset.target === tabName);
        });
      });
    }

    closeDetails() {
      this.details.removeAttribute('open');
      this.details.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }

  customElements.define('mega-menu', MegaMenu);
}
